import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Panel} from 'primereact/panel';
import {Dropdown} from 'primereact/dropdown';
import {Calendar} from 'primereact/calendar';
import {InputSwitch} from 'primereact/inputswitch';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';    
import moment from 'moment';
import {Toast} from 'primereact/toast';
import Messages from '../../../shared/UI/Messages/Messages';

import {  DROPDOWN_CONFIG, DAILY_SHIFT_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS, TIME_DURATION, REDIRECT_TO_URL } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';

class AddDailyShift extends Component {
    state = {
        display : true,
        lunchRules: false,
        shiftCategoryies: [
            {label : 'Week-Days', value: 1},
            {label : 'Week-Ends', value: 2},
            {label : 'Holidays', value: 3}
        ],       
        date4: null,
        date5: null,
        rows: [],
        type : 'add',
        shiftCategory : null,
        shiftName :'',
        ShiftId : '',
        Description : '',
        ShiftStart : "",
        ShiftEnd : "",
        ShiftDuration :"",
        LunchStart : "",
        LunchEnd : "",
        LunchDuration : "",
        IsShiftRuleEnabled : false,
        IsLunchRuleEnabled : false,
        RoundStarts : "",
        RoundEnd : "",
        GraceStarts : "",
        GraceEnd : "",
        DockStarts : "",
        DockEnd : "",
        employeeShiftId : null
    }


    componentDidMount(){       
        
        this.props.getMasterTableList('User/GetShift');   

        this.getAccess = HASACCESS(DAILY_SHIFT_SUBMENU_ID);

        let type = this.props.match.params.type;
        if(type !== 'add'){
            setTimeout(() => {
                this.fetchSingleProcess();
            },1000)
        }
    }


    fetchSingleProcess = () =>{
   
        let id = this.props.match.params.id;   
        let type = this.props.match.params.type;
        let storageItems = [];

        if(this.props.tableLists && this.props.tableLists.length > 0) {
            storageItems = this.props.tableLists;
        }
        if(storageItems){
            let filterData = storageItems.filter(list => {
                return parseInt(list.id) === parseInt(id);
            }).reduce((arr,el) => {
                return el;
            },{});
       
            let currentDate = moment().format('DD-MMM-YYYY');
            let shiftStart = '';
            if(filterData.shiftStart!=='' && filterData.shiftStart!==null){
                shiftStart  = new Date(currentDate+' '+filterData.shiftStart);
            }
            let lunchStart = '';
            if(filterData.lunchStart!=='' && filterData.lunchStart!==null){
                lunchStart  = new Date(currentDate+' '+filterData.lunchStart);
            }
            let shiftEnd = '';
            if(filterData.shiftEnd!=='' && filterData.shiftEnd!==null){
                shiftEnd  = new Date(currentDate+' '+filterData.shiftEnd);
            }
            let lunchEnd = '';
            if(filterData.lunchEnd!=='' && filterData.lunchEnd!==null){
                lunchEnd  = new Date(currentDate+' '+filterData.lunchEnd);
            }
            let roundStarts = '';
            if(filterData.roundStarts!=='' && filterData.roundStarts!==null){
                roundStarts  = new Date(currentDate+' '+filterData.roundStarts);
            }
            let roundEnd = '';
            if(filterData.roundEnd!=='' && filterData.roundEnd!==null){
                roundEnd  = new Date(currentDate+' '+filterData.roundEnd);
            }

            let graceEnd = '';
            if(filterData.graceEnd!=='' && filterData.graceEnd!==null){
                graceEnd  = new Date(currentDate+' '+filterData.graceEnd);
            }

            let graceStarts = '';
            if(filterData.graceStarts!=='' && filterData.graceStarts!==null){
                graceStarts  = new Date(currentDate+' '+filterData.graceStarts);
            }

            let dockStarts = '';
            if(filterData.dockStarts!=='' && filterData.dockStarts!==null){
                dockStarts  = new Date(currentDate+' '+filterData.dockStarts);
            }
            let dockEnd = '';
            if(filterData.dockEnd!=='' && filterData.dockEnd!==null){
                dockEnd  = new Date(currentDate+' '+filterData.dockEnd);
            }
            
            if(filterData){
                var data = {
                    type:type,
                    shiftName : filterData.shiftName,
                    ShiftId :   filterData.shiftId,
                    shiftCategory : filterData.shiftCategory,
                    Description : filterData.description,
                    ShiftStart : shiftStart,
                    ShiftEnd :shiftEnd,
                    ShiftDuration :filterData.shiftduration,
                    LunchStart :lunchStart,
                    LunchEnd : lunchEnd,
                    LunchDuration : filterData.lunchDuration,
                    IsShiftRuleEnabled : filterData.isShiftRuleEnabled,
                    IsLunchRuleEnabled : filterData.isLunchRuleEnabled,
                    RoundStarts : roundStarts,
                    RoundEnd : roundEnd,
                    GraceStarts : graceStarts,
                    GraceEnd : graceEnd,
                    DockStarts : dockStarts,
                    DockEnd : dockEnd,
                    employeeShiftId : filterData.employeeShiftId
                }
                this.setState(data);
                
            }
        }

    }


    actionTemplate = (rowData, column) => {
        let rowIndex = column.rowIndex;
        return <div>
            <Button type="button" icon="pi pi-trash" className="p-button-danger" onClick={() => this.removeField(rowIndex)} ></Button>
        </div>;
    }

  
    add = () => {

        let ShiftStart = '';
        if(this.state.ShiftStart !==''){ShiftStart  = new moment(this.state.ShiftStart);ShiftStart  = ShiftStart.format("HH:mm");}
        let ShiftEnd = '';
        if(this.state.ShiftEnd !==''){ShiftEnd  = new moment(this.state.ShiftEnd);ShiftEnd  = ShiftEnd.format("HH:mm");}
        let LunchStart = '';
        if(this.state.LunchStart !==''){LunchStart  = new moment(this.state.LunchStart);LunchStart  = LunchStart.format("HH:mm");}
        let LunchEnd = '';
        if(this.state.LunchEnd !==''){LunchEnd  = new moment(this.state.LunchEnd);LunchEnd  = LunchEnd.format("HH:mm");}
        let RoundStarts = '';
        if(this.state.RoundStarts !==''){RoundStarts  = new moment(this.state.RoundStarts);RoundStarts  = RoundStarts.format("HH:mm");}
        let ShiftDuration = '';
        if(ShiftStart !=='' && ShiftEnd !==''){ 
            ShiftDuration = TIME_DURATION(ShiftStart,ShiftEnd);
            let checkTst = ShiftDuration.split(':');
            if(checkTst[0] < 0 && checkTst[1] < 0 ){
                this.growl.show({severity: 'error', summary: null, detail: 'Shift duration should be positive digits'});  
            }
        }else{
                this.growl.show({severity: 'error', summary: null, detail: 'Shift start and end is required'});
        }

        let LunchDuration = '';
        if(LunchStart !=='' && LunchEnd !==''){
            LunchDuration = TIME_DURATION(LunchStart,LunchEnd);
            let checkTst = LunchDuration.split(':');
            if(checkTst[0] < 0  && checkTst[1] < 0){
                this.growl.show({severity: 'error', summary: null, detail: 'Lunch duration should be positive digits'});  
            }
        }else{
            this.growl.show({severity: 'error', summary: null, detail: 'Lunch start and end is required'});
        }


        let RoundEnd = '';
        if(this.state.RoundEnd !==''){
            RoundEnd  = new moment(this.state.RoundEnd);
            RoundEnd  = RoundEnd.format("HH:mm");//:ss
        }

        let GraceStarts = '';
        if(this.state.GraceStarts !==''){
            GraceStarts  = new moment(this.state.GraceStarts);
            GraceStarts  = GraceStarts.format("HH:mm");//:ss
        }

        let GraceEnd = '';
        if(this.state.GraceEnd !==''){
            GraceEnd  = new moment(this.state.GraceEnd);
            GraceEnd  = GraceEnd.format("HH:mm");//:ss
        }
        let DockStarts = '';
        if(this.state.DockStarts !==''){
            DockStarts  = new moment(this.state.DockStarts);
            DockStarts  = DockStarts.format("HH:mm");//:ss
        }

        let DockEnd = '';
        if(this.state.DockEnd !==''){
            DockEnd  = new moment(this.state.DockEnd);
            DockEnd  = DockEnd.format("HH:mm");//:ss
        }

        
        let data = {
            ShiftName:this.state.shiftName,
            ShiftId:this.state.ShiftId,
            ShiftCategory:this.state.shiftCategory,
            Description:this.state.Description,
            IsActive:true,
            ShiftStart:ShiftStart,
            ShiftEnd:ShiftEnd,
            ShiftDuration:ShiftDuration,
            LunchStart:LunchStart,
            LunchEnd:LunchEnd,
            LunchDuration:LunchDuration,
            IsShiftRuleEnabled:true,
            IsLunchRuleEnabled:this.state.IsLunchRuleEnabled,
            ShiftRound:null,
            ShiftGrace:null,
            WeeklyWorkingHr:null,
            RoundStarts:RoundStarts,
            RoundEnd:RoundEnd,
            GraceStarts:GraceStarts,
            GraceEnd:GraceEnd,
            DockStarts:DockStarts,
            DockEnd:DockEnd,
            HolidayPaid:"yes",
            AutoAfter:null,
            WorkPersSubGrp:null,
            Zvariant:null,
            BegBegTolerance:null,
            BegEndTolerance:null,
            EndBegTolerance:null,
            EndEndTolerance:null,
            EmployeeShiftId:null,
        }

        if(this.state.type === 'edit'){
            data.EmployeeShiftId = this.state.employeeShiftId;
            data.Id = this.props.match.params.id;
        }

        this.props.processDynamicData('shift',this.state.type,data,'User/GetShift');
        

    }

    resetData = () => {

    }

    documentAdd = () => {

        let newDoc = {no : 1, hour:'1 X 8 = 8hours',percentage:""};
  
        let docValue = [...this.state.rows, newDoc];
      
        this.setState({rows:docValue})
    }

    noEditor =  (props) => {
        return this.inputTextEditor(props, 'percentage');
    }
    onEditorValueChange = (props, value) => {
        let updatedValue = [...props.value];
        updatedValue[props.rowIndex][props.field] = value;
        this.setState({documentDetails: updatedValue});
    }

    inputTextEditor = (props, field) => {
        return <InputText type="text" value={props.rowData[field]} onChange={(e) => this.onEditorValueChange(props, e.target.value)} />;
    }


    removeField  = (removeIndex) => {

        const updatedDeptValue = this.state.rows.filter((value,index) => {
            return removeIndex !== index;
        })
        this.setState({rows:updatedDeptValue})

    }

    change = (e) => {
        let {name, value} = e.target;
        this.setState({[name]:value,touch:true})

        setTimeout(() => {
            this.checkDuration();
        },2000)
        
        
    }

    checkDuration = () => {
        if(this.state.LunchStart !=='' && this.state.LunchEnd !==''){
            let LunchStart = new moment(this.state.LunchStart);
            LunchStart = LunchStart.format("HH:mm");
            let LunchEnd = new moment(this.state.LunchEnd);
            LunchEnd = LunchEnd.format("HH:mm");
            let LunchDuration = TIME_DURATION(LunchStart,LunchEnd);
            let checkTst = LunchDuration.split(':');
            if(checkTst[0] < 0  && checkTst[1] < 0){
                this.growl.show({severity: 'error', summary: null, detail: 'Lunch duration should be positive digits'});  
            }else{
                this.setState({LunchDuration:LunchDuration})
            }
        }
    }


    render() {   

        if(this.props.success){
            REDIRECT_TO_URL('/daily-shift/',this.props);
        }

        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}

        let isEnabled = (this.state.shiftCategory!==null && this.state.shiftName!=='' && this.state.ShiftId!=='' && this.state.Description!=='');
        return (
            <div className="p-grid ">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Add Daily Shift</h1>
           
                        <div className="p-grid mt2">
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Shift Category <span className="requiredColor">*</span></label>
                                <div className="mt1"> 
                                <Dropdown className="p-col-12" placeholder="Select Shift Category" options={this.state.shiftCategoryies} name="shiftCategory" value={this.state.shiftCategory} onChange={this.change}  {...DROPDOWN_CONFIG} />
                                </div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Shift Name <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="shiftName" value={this.state.shiftName} placeholder="Shift Name" onChange={this.change} /></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Shift Code <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="ShiftId" value={this.state.ShiftId}  placeholder="Shift Code"  onChange={this.change}/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Shift Decription <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="Description" placeholder="Shift Decription" value={this.state.Description}  onChange={this.change}/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6 mt3">
                                <Panel header="Shift Rules" toggleable={true}>
                               
                                    <div className="p-grid">
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Shift Start</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <Calendar placeholder="Time" timeOnly={true} showTime={true} name="ShiftStart" value={this.state.ShiftStart} onChange={this.change}/>
                                        </div>
                                        
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Shift End</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <Calendar placeholder="Time" timeOnly={true} showTime={true} name="ShiftEnd" value={this.state.ShiftEnd} onChange={this.change}/>
                                        </div>



                                        <div className="p-col-12 p-md-4">
                                            <label>Round (Minutes)</label>
                                        <Calendar placeholder="Time" timeOnly={true} showTime={true} name="RoundStarts" value={this.state.RoundStarts} onChange={this.change} className="mt1" style={{width:'10em'}}/>
                                        </div>

                                        <div className="p-col-12 p-md-4">
                                            <label>Grace (Minutes)</label>
                                        <Calendar placeholder="Time" timeOnly={true} showTime={true} name="GraceStarts" value={this.state.GraceStarts} onChange={this.change} className="mt1"  style={{width:'10em'}}/>
                                        </div>

                                        <div className="p-col-12 p-md-4">
                                            <label>Dock (Minutes)</label>
                                            <Calendar placeholder="Time" timeOnly={true} showTime={true} name="DockStarts" value={this.state.DockStarts} onChange={this.change} className="mt1"  style={{width:'10em'}}/>
                                        </div>


                                        <div className="p-col-12 p-md-4">
                                        <Calendar placeholder="Time" timeOnly={true} showTime={true} name="RoundEnd" value={this.state.RoundEnd} onChange={this.change}  style={{width:'10em'}}/>
                                        </div>

                                        <div className="p-col-12 p-md-4">
                                        <Calendar placeholder="Time" timeOnly={true} showTime={true} name="GraceEnd" value={this.state.GraceEnd} onChange={this.change}  style={{width:'10em'}}/>
                                        </div>

                                        <div className="p-col-12 p-md-4">
                                            <Calendar placeholder="Time" timeOnly={true} showTime={true} name="DockEnd" value={this.state.DockEnd} onChange={this.change}  style={{width:'10em'}}/>
                                        </div>


                                    </div> 
                                </Panel>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6 mt3">
                                <Panel header="Lunch Rules" toggleable={true}>

                                    
                               
                                    <div className="p-grid">

                                
                                        <div className="p-col-12 p-md-2 ">
                                            
                                        </div>

                                        <div className="p-col-12 p-md-6">
                                        <InputSwitch checked={this.state.IsLunchRuleEnabled} value={this.state.IsLunchRuleEnabled} name="IsLunchRuleEnabled" onChange={this.change}/> 
                                            <label htmlFor="input" style={{position:'relative',top:'-7px',left:'9px'}}>Lunch Rules Enabled</label>
                                        </div>



                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Lunch Start</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <Calendar placeholder="Time" timeOnly={true} showTime={true} name="LunchStart" value={this.state.LunchStart} onChange={this.change}/>
                                        </div>
                                        
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Lunch End</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <Calendar placeholder="Time" timeOnly={true} showTime={true} name="LunchEnd" value={this.state.LunchEnd} onChange={this.change}/>
                                        </div>

                                        

                                        <div className="p-col-12 p-md-6 mt3">
                                            <label htmlFor="input">Lunch Duration</label>
                                        </div>
                                        <div className="p-col-12 p-md-6 mt3">
                                        <InputText className="p-col-12" name="LunchDuration" placeholder="Lunch Duration"  value={this.state.LunchDuration} readOnly onChange={this.change}/>
                                        </div>

                                    </div> 
                                </Panel>
                            </div>

                       
                            <div className="p-col-12 p-lg-12">
                                <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={"/daily-shift"} />
                            </div>
                         

                            {/* <div className="p-col-12 p-md-6 p-lg-12 mt3">
                                <div className="p-col-12 p-md-3 p-lg-2">
                                    <div className="mt1">
                                        <Button onClick={this.documentAdd}  label="Add" className="p-button-primary"/>
                                    </div>                                
                                </div>
                                <DataTable className="animated fadeIn" rowHover  responsive value={this.state.rows} editable={true}>
                                    <Column field="no" header="S.No"  style={{height: '3.5em'}}/>
                                    <Column field="hour" header="Hour"  style={{height: '3.5em'}}/>
                                    <Column field="percentage" header="Percentage" editor={this.noEditor} style={{height: '3.5em'}}/>
                                    <Column body={this.actionTemplate} header="Delete "style={{textAlign:'center', width: '8em'}}/>
                                </DataTable> 
                                </div> 
                            */}
                        </div> 
                           
           
                       
                    </div>
                         
                </div>
                
            </div>
        );
    }
}


const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        userDetail : state.auth.userDetail,
        userPref : state.auth.userPref,
        loading : state.master.loading,
        error : state.master.error,
        success : state.master.success,
        tableLists : state.master.tableLists,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
    }
}
  
export default connect(mapStateToProps,mapDispatchToProps)(AddDailyShift);